export default {
  default: () => import("/builds/fatec-developpement/copilot/copilot-front/layouts/default.vue").then(m => m.default || m),
  headeronly: () => import("/builds/fatec-developpement/copilot/copilot-front/layouts/headeronly.vue").then(m => m.default || m),
  loggedout: () => import("/builds/fatec-developpement/copilot/copilot-front/layouts/loggedout.vue").then(m => m.default || m)
}